import React, { FC } from 'react';
import VideoPlayer from '../../@shared/videoPlayer';
import Breakpoints from '../../../constants/breakpoints.constants';
import { TMediaElementProps } from '../types/userExperience.types';
import { googleMediaPlay } from '../../../utils/analytics';
import { lineTestimonialsVideoPlay } from '../../../constants/analytics.constants';
import useSitecoreContext from '../../../hooks/useSitecoreContext';

const MediaElement: FC<TMediaElementProps> = (props) => {
  const { videoUrl, isVideo, bigthumbnail, thumbnail, altText } = props;
  const {sitecoreContext} = useSitecoreContext();
  const productLine = sitecoreContext?.analytics?.['productLine'] ? sitecoreContext?.analytics?.['productLine'] : undefined;
  if (videoUrl && isVideo) {
    return (
      <div className={'user-experience__column user-experience__video'}>
        <div className={'user-experience__video-wrapper'}>
          <VideoPlayer
            link={videoUrl}
            autoPlay={true}
            playCallback={() => {
              googleMediaPlay(lineTestimonialsVideoPlay, altText, productLine);
            }}
            showThumbnail={true}
            editorialImageProps={{
              desktopImage: thumbnail,
              mobileImage: thumbnail,
              isEditable: true,
              alt: altText,
            }}
          />
        </div>
      </div>
    );
  }
  return (
    <>
      <picture className="user-experience__image">
        <source srcSet={bigthumbnail} media={`(min-width: ${Breakpoints['tbl-p']}px)`} />
        <source srcSet={thumbnail} media={`(min-width: ${Breakpoints.xs}px)`} />
        <img loading="lazy" className={'user-experience__column user-experience__image'} src={bigthumbnail} alt={altText} />
      </picture>
    </>
  );
};

export default MediaElement;
